/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPASSETTYPE = {
    Security: 'S',
    WrapFund: 'W',
    Psp: 'P',
    Cash: 'C',
    JustLifetimeIncomeFund: 'J'
} as const;
export type IAPASSETTYPE = typeof IAPASSETTYPE[keyof typeof IAPASSETTYPE];


export function IAPASSETTYPEFromJSON(json: any): IAPASSETTYPE {
    return IAPASSETTYPEFromJSONTyped(json, false);
}

export function IAPASSETTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPASSETTYPE {
    return json as IAPASSETTYPE;
}

export function IAPASSETTYPEToJSON(value?: IAPASSETTYPE | null): any {
    return value as any;
}

